import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  children: React.ReactNode;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-197" data-mp="3f25cf5v46ml7">
      {eyebrow && <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-[var(--lilac)]" data-id="element-198" data-mp="3jzx7g8r22otm">
          {eyebrow}
        </p>}
      <h2 className="font-display text-3xl font-extrabold leading-tight text-[var(--cream)] sm:text-4xl md:text-5xl" data-id="element-199" data-mp="bloh77c0aa4m">
        {children}
      </h2>
    </div>;
}